import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import translate from 'core/hooks/useResource'
import useSSR from '@core/hooks/useSSR'
import { modelTypes } from 'app/constants'
import setupNewsletter from 'features/newsletter/newsletter'

export default function Newsletter() {
    const {
        newsletterSettings,
    } = useSSR([modelTypes.newsletterSettings])

    const {
        allowToUnsubscribe,
    } = newsletterSettings

    useEffect(() => {
        setupNewsletter()
    }, [])

    return (
        <section className="newsletter">
            <div className="title">
                {translate('newsletter.title')}
            </div>
            
            <div className="newsletter-subscribe" id="newsletter-subscribe-block">
                <div className="newsletter-email">
                    <input asp-for="NewsletterEmail" id="newsletter-email" class="newsletter-subscribe-text" placeholder={translate("Newsletter.Email.Placeholder")} aria-label={translate('newsletter.subscribe')} />
                    <input
                        type="button"
                        value={allowToUnsubscribe ? translate('newsletter.options.subscribe') : translate('newsletter.options.send')}
                        id="newsletter-subscribe-button"
                        className="button-primary newsletter-subscribe-button" />
                    
                    <div id="subscribe-loading-progress" style="display: none;">laddar...</div>
                    
                    {allowToUnsubscribe && (
                        <div class="unsub">
                            <div class="options">
                                <span class="subscribe">
                                    <input id="newsletter_subscribe" type="radio" value="newsletter_subscribe" name="newsletter_block" checked="checked"/>
                                    <label for="newsletter_subscribe">@T("Newsletter.Options.Subscribe")</label>
                                </span>
                                <span class="unsubscribe">
                                    <input id="newsletter_unsubscribe" type="radio" value="newsletter_unsubscribe" name="newsletter_block"/>
                                    <label for="newsletter_unsubscribe">@T("Newsletter.Options.Unsubscribe")</label>
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div class="newsletter-result" id="newsletter-result-block" />
        </section> 
    )
}